import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { form: String, name: String, value: String }

  submit() {
    const form = document.getElementById(this.formValue)
    if (!form) return

    const submitter = document.createElement("button")
    Object.assign(submitter, { type: "submit", name: this.nameValue, value: this.valueValue, hidden: true })
    submitter.setAttribute("data-submit-placeholder-skip", "")
    form.append(submitter)
    form.requestSubmit(submitter)
    submitter.remove()
  }
}
